import {
  Component,
  inject,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AccordionComponent } from '@ppl/ui';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';
import { ButtonComponent } from '@ppl/ui';
import {  ListTableComponent  } from '@ppl/ui';
import {
  MEMBER_VIEW_PAGE_IDS,
  TABS,
} from '../../../../shared/constants/page.constants';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import {
  DialogService,
  DialogConfig,
} from '../../../../shared/services/dialog.service';
import { TimesheetViewComponent } from '../timesheet-view/timesheet-view.component';
import { TimesheetNewEntriesComponent } from '../timesheets-add-entries/timesheets-add-entries.component';
import { TimesheetFilterComponent } from '../timesheet-filter/timesheet-filter.component';
import { LookupService } from '../../../../services/lookup.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { ListService } from '../../../../shared/services/list.service';
import { TimesheetProviderProcessedListComponent } from "../timesheet-provider-processed-list/timesheet-provider-processed-list.component";
import { TimesheetProviderDeniedListComponent } from "../timesheet-provider-denied-list/timesheet-provider-denied-list.component";
import { CommonModule } from '@angular/common';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-timesheet-provider-list',
  standalone: true,
  imports: [
    AccordionComponent,
    ListTableComponent,
    NgZorroModule,
    ButtonComponent,
    AuthorizeDirective,
    TimesheetNewEntriesComponent,
    NzSelectModule,
    FormsModule,
    NzFormModule,
    ReactiveFormsModule,
    TimesheetViewComponent,
    TimesheetProviderProcessedListComponent,
    TimesheetProviderDeniedListComponent
  ],
  templateUrl: './timesheet-provider-list.component.html',
  styleUrl: './timesheet-provider-list.component.css',
})
export class TimesheetProviderListComponent implements OnInit {
  entry!: string;
  sharedDataKey: string = STATIC_DATA.SHARED_REFERRAL_DATA;
  pageId = '';
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  actionButtons: TableRowActionsModel = new TableRowActions({ view: true });
  @ViewChild('timesheetDialog') timesheetDialog!: TemplateRef<any>;
  @ViewChild('timesheetViewDialog') timesheetViewDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  tabId: string = TABS.TIMESHEET;
  programName!: string;
  timeEntry = '';
  title = '';
  isProcessed = false;
  inProgressPayroll: any;
  statusList: any;
  timesheetSearchForm!: FormGroup;
  providerId: any;
  action: any;
  addDialogId: any;
  payrollScheduleId: any;
  timesheetData: any;
  filetredPayPeriod: any;
  consumers: any[] = [];
  payPeriod: any[] = [];
  @Input() isReadOnly = false;

  constructor(
    private fb: FormBuilder,
    private lookupService: LookupService,
    private timesheetService: TimesheetService,
    private listService: ListService,
    private userService: UserService,
    private allowListStore: AllowListAuthStore
  ) { }

  ngOnInit(): void {
    this.entry = this.userService.getLeadEntry() ?? '';
    this.pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
    const selectedProgram = this.userService.getSelectedProgram();
    this.providerId = JSON.parse(this.userService.getSelectedLead()!);
    this.programName = selectedProgram?.program_code ?? '';
    const userDetails = this.userService.getUserDetails();
    if (!userDetails) {
      console.error('no user details found');
      return;
    }
    const isInRole = selectedProgram?.roles.some((role: any) => role.role_name === 'PPL Staff Tier 1') && userDetails.usertype_lkp === 'FMS';
    this.isReadOnly = isInRole ? true : false; 

    this.statusList = this.lookupService
      .getLookupValue('Business Status')
      .filter((item: any) => ['P', 'D'].includes(item.lkpValueCode));

    this.timesheetSearchForm = this.fb.group({
      payPeriod: [null],
      consumer: [null],
      status: [null],
      chequeNumber: [null],
    });
    this.setPageAccess();
    this.getConsumers();
    this.getPayPeriod();
    this.getInitData();
  }

  getInitData() {

    const inProcessPayload = this.buildRequestPayload(
      'providertimesheetlist1',
      'tasMasterPayrollScheduleId'
    );

    this.listService
      .getListData(inProcessPayload, 'claims')
      .subscribe((data: any) => {
        this.inProgressPayroll = this.filterRecords(data.responsedata);
      });
  }

  filterPayrollDates(payrolls: any, flow: any) {
    const today = new Date();
    if (flow === 'timeEntry') {
      return payrolls.filter((payroll: any) => {
        const startDate = new Date(payroll.payrollStartDate);
        const endDate = new Date(payroll.payrollEndDate);
        return startDate <= today || (today >= startDate && today <= endDate);
      });
    }
    else {
      const twoWeeksAgo = new Date();
      twoWeeksAgo.setDate(today.getDate() - 14);
      return payrolls.filter((payroll: any) => {
        const startDate = new Date(payroll.payrollStartDate);
        const endDate = new Date(payroll.payrollEndDate);
        return (startDate >= twoWeeksAgo || (twoWeeksAgo >= startDate && twoWeeksAgo <= endDate));
      });
    }
  };

  buildRequestPayload(pageName: string, orderBy: string) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: '1',
      searchParam: [
        {
          jsonPath: 'providerId',
          value: this.providerId,
          operator: 'Equal',
        },
      ],
      orderByColumn: [orderBy],
      orderBy: ['desc'],
    };
    return payload;
  }

  getConsumers() {
    this.timesheetService
      .getConsumerList(this.programName, this.providerId)
      .subscribe((data: any) => {
        this.consumers = data.responsedata;
      });
  }

  getPayPeriod() {
    this.timesheetService
      .getPayPeriod(this.programName)
      .subscribe((data: any) => {
        this.payPeriod = data.responsedata;
      });
  }

  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
    this.isPageRestrictionLoaded = true;
  }

  onView(data: any) {
    this.timeEntry = 'timeEntry';
    this.payrollScheduleId = data.tasMasterPayrollScheduleId;
    if (this.isProcessed) {
      this.openViewPopup();
    } else {
      this.filetredPayPeriod = this.filterPayrollDates(this.payPeriod, 'timeEntry');
      const tsPayload = {
        programCode: this.programName,
        consumerId: data.consumerId,
        providerId: data.providerId,
        payrollScheduleId: data.tasMasterPayrollScheduleId,
      };
      this.timesheetService.getTimesheet(tsPayload).subscribe((response: any) => {
        this.action = 'edit';
        this.title = 'Edit Time Entry';
        this.timesheetData = response.responsedata;
        if (this.timesheetData) {
          this.timesheetData.lineItem = this.timesheetData.lineItem || {};
          this.timesheetData.lineItem.serviceStartDate = data.fromDate;
          this.timesheetData.lineItem.serviceEndDate = data.toDate;
        }
        this.openAddPopup();
      });
    }
  }

  timesheetAdded(event: any) {
    if (event.timesheetAdded) {
      this.closeAddDialog();
    }
  }

  closeAddDialog() {
    if (this.addDialogId) {
      this.dialogSvc.closeDialog(this.addDialogId);
      this.getInitData();
      this.addDialogId = null;
    }
  }

  addTimeentries() {
    this.filetredPayPeriod = this.filterPayrollDates(this.payPeriod, 'timeEntry');
    this.timeEntry = 'timeEntry';
    this.title = 'Add New Time Entry';
    this.action = 'add';
    this.openAddPopup();
  }

  openAddPopup() {
    const dialogConfig: DialogConfig = {
      title: this.title,
      okText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.addDialogId = this.dialogSvc.openDialog(
      this.timesheetDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  filterRecords(data: any) {
    data.sort((a: any, b: any) => {
      const dateA = new Date(a.fromDate);
      const dateB = new Date(b.fromDate);
      return dateA.getTime() - dateB.getTime(); // Sorts in ascending order
    });

    return data;
  }

  onAction(event: any, isProcessed: boolean) {
    if (event.action === 'view') {
      this.isProcessed = isProcessed;
      this.onView(event.data);
    }
  }

  openViewPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Timesheet',
      okText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.timesheetViewDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  handleCancel() {
    this.timeEntry = '';
    this.timesheetData = undefined;
  }
}
